import validator from "validator";

interface Values {
  amount: string;
  comment: string;
}

export function makeServicePaymentValidator(values: Values) {
  const errors: any = {};

  if (!values.amount?.trim()) {
    errors.amount = "Amount is required.";
  } else if (!validator.isNumeric(values.amount.trim())) {
    errors.amount = "Amount is not valid";
  } else if (values.amount.trim().split(".")[1]?.length > 2) {
    errors.amount = "Max 2 digits allowed after decimal point";
  } else if (+values.amount < 1) {
    errors.amount = "Amount must be greater or equal to 1.";
  } else if (+values.amount > 10000) {
    errors.amount = "Amount must be less or equal to 10000.";
  }

  if (!values.comment?.trim()) {
    errors.comment = "Comment is required.";
  } else if (values.comment.trim().length < 5) {
    errors.comment = "Comment must have minimum 5 characters.";
  } else if (values.comment.trim().length > 255) {
    errors.comment = "Comment maximum length should be 255 characters.";
  }

  return errors;
}
